module.exports = __webpack_public_path__ + "img/image10.08c0fd68.jpg";